import styled from "styled-components";

export const NotFoundWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const NotFoundContainer = styled.div`
  display: flex;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 96px;
  padding: 48px 24px;
`;

export const NotFoundTextSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  align-self: stretch;

  & > p {
    color: ${({ theme }) => theme.colors.default[600]};
  }

  span {
    color: ${({ theme }) => theme.colors.primary.default};
  }
`;

export const NotFoundFooterLinks = styled.div`
  display: flex;
  max-width: 973px;
  padding: 48px;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  width: 100%;
  border-radius: 24px;
  background: ${({ theme }) => theme.colors.default[50]};
`;

export const NotFoundFooterLink = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.colors.primary.default};
`;
